import { getDeepProp } from '../../../utils/js.js';
import { FieldValid, FieldLoading } from '../Field/Validation/types.js';
import { mergeValidationStates } from '../Field/Validation/validations.js';

function fillValidationWithFieldValid(fieldNames) {
    return (multiFieldValidations) => {
        fieldNames
            .filter((fn) => !multiFieldValidations.some((mfv) => mfv.fieldName === fn))
            .forEach((fn) => {
            multiFieldValidations.push({ fieldName: fn, validation: FieldValid });
        });
        return multiFieldValidations;
    };
}
function getFieldValidations(fieldName, values, multiFieldValidations) {
    return multiFieldValidations
        .filter((mfv) => mfv.fieldNames.includes(fieldName))
        .map((mfv) => {
        let validations = mfv.validate(values);
        if (validations instanceof Promise) {
            validations = validations.then(fillValidationWithFieldValid(mfv.fieldNames));
        }
        else {
            validations = fillValidationWithFieldValid(mfv.fieldNames)(validations);
        }
        return ({ fieldNames: mfv.fieldNames, validations });
    });
}
function existsAsyncValidations(validations) {
    return validations.some((v) => v.validations instanceof Promise);
}
function getValidationsByFielName(validations, init = {}) {
    return validations.reduce((newVals, val) => {
        const { fieldName, validation } = val;
        const result = Object.assign(Object.assign({}, newVals), { [fieldName]: mergeValidationStates(newVals[fieldName], validation) });
        return result;
    }, init);
}
function getSyncValidationsByFielName(validations) {
    return validations.reduce((vals, val) => {
        const newValidations = val.validations;
        return getValidationsByFielName(newValidations, vals);
    }, {});
}
function changeComponentValidation(component, value, validation, isOnInitialization) {
    component === null || component === void 0 ? void 0 : component.setFormValidation(value, validation || FieldValid, isOnInitialization);
}
function changeFieldValidations(values, validationsByFieldName, getComponent, isOnInitialization) {
    Object.keys(validationsByFieldName)
        .forEach((k) => {
        changeComponentValidation(getComponent(k), getDeepProp(k, values), validationsByFieldName[k], isOnInitialization);
    });
}
function notifySyncValidationsAndReturnFieldValidation(values, validations, getComponent, isOnInitialization) {
    const validationsByFieldName = getSyncValidationsByFielName(validations);
    changeFieldValidations(values, validationsByFieldName, getComponent, isOnInitialization);
}
function notifyAsyncValidations(values, validations, fieldName, getComponent, isOnInitialization) {
    const syncValidations = (validations.filter((v) => !(v.validations instanceof Promise)))
        .reduce((all, vals) => [...all, ...vals.validations], []);
    const asyncValidations = (validations.filter((v) => (v.validations instanceof Promise)))
        .reduce((all, vals) => [...all, vals.validations], []);
    Promise.all(asyncValidations)
        .then((results) => results.reduce((all, vals) => [...all, ...vals], syncValidations))
        .then((vals) => {
        const validationsByFieldName = getValidationsByFielName(vals);
        if (!validationsByFieldName[fieldName]) {
            validationsByFieldName[fieldName] = FieldValid; // tolgo lo stato di loading
        }
        changeFieldValidations(values, validationsByFieldName, getComponent, isOnInitialization);
    });
    changeComponentValidation(getComponent(fieldName), getDeepProp(fieldName, values), FieldLoading, isOnInitialization);
}
function validateFields(fieldName, values, multiFieldValidations, isOnInitialization, getComponent) {
    const validations = getFieldValidations(fieldName, values, multiFieldValidations);
    if (existsAsyncValidations(validations)) {
        notifyAsyncValidations(values, validations, fieldName, getComponent, isOnInitialization);
    }
    else {
        notifySyncValidationsAndReturnFieldValidation(values, validations, getComponent, isOnInitialization);
    }
}

export { validateFields as default };
